import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constant/api";
import { Link } from "react-router-dom";

function HomeCarousel({ items }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, [items.length]);

  return (
    <div>
      <div className="relative mx-auto w-full max-w-10xl my-5 px-5">
        <div className="flex items-center justify-center transition duration-500 ease-out">
          {/* Current Slide */}
          <div className="sm:flex-1">
            {/* <Link to={`/banner/${items[currentIndex]?.id}/`}>
              <img
                src={`${BASE_URL}${items[currentIndex]?.banner}`}
                alt={`Slide ${currentIndex + 1}`}
                className="w-screen h-[150px] md:h-[290px] object-fill rounded-sm"
                loading="lazy" // Improved performance
              />
            </Link> */}
            <Link to={`${items[currentIndex]?.path}`}>
              <img
                src={`${items[currentIndex]?.banner}`}
                alt={`Slide ${currentIndex + 1}`}
                className="w-screen h-[100px] md:h-auto object-fill rounded-sm"
                loading="lazy" // Improved performance
              />
            </Link>
          </div>
        </div>
      </div>

      {/* Buttons at the bottom */}
      <div className="flex justify-center gap-2 mt-4">
        {items.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`h-2 w-2 rounded-full transition-colors duration-500 ${index === currentIndex ? "bg-brand-primary" : "bg-gray-300"}`}
            aria-label={`Go to slide ${index + 1}`} // Improved accessibility
          />
        ))}
      </div>
    </div>
  );
}

export default HomeCarousel;